import { licenseConstants } from '../constants';
import { licenseService } from '../services';
import { alertActions, userActions } from './';

export const licenseActions = {
  create,
  update,
  getAll,
  getAllForUser,
  getAllForAdmin,
  exportValidatedLicenses,
};

function create(license, props) {
  return dispatch => {
    dispatch(alertActions.info(props.i18n.t('creationInProgress')));
    dispatch(request({ license }));

    licenseService.create(license).then(
      license => {
        dispatch(success(license));
        if (license.temporaryLicense) {
          dispatch(
            alertActions.success(
              props.i18n.t('temporaryLicenseCreationSuccess')
            )
          );
        } else {
          dispatch(
            alertActions.success(props.i18n.t('licenseCreationSuccess'))
          );
        }
        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 10000);
      },
      error => {
        if (error === 401) {
          console.log('unauthorized');
          dispatch(userActions.logout());
          dispatch(failure(error));
          props.history.push('/signin');
        } else {
          dispatch(failure(error));
          dispatch(alertActions.error(props.i18n.t('licenseCreationError')));
        }
      }
    );
  };

  function request(license) {
    return { type: licenseConstants.LICENSE_CREATION_REQUEST, license };
  }
  function success(license) {
    return { type: licenseConstants.LICENSE_CREATION_SUCCESS, license };
  }
  function failure(error) {
    return { type: licenseConstants.LICENSE_CREATION_FAILURE, error };
  }
}

function update(licenseId, status, currentPage, filterStatus, props) {
  return dispatch => {
    dispatch(request({ status }));

    licenseService.update(licenseId, status, currentPage, filterStatus).then(
      response => {
        dispatch(success(response));
        dispatch(
          alertActions.success(props.i18n.t('licenseStatusUpdateSuccess'))
        );
        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 10000);
      },
      error => {
        if (error === 401) {
          console.log('unauthorized');
          dispatch(userActions.logout());
          dispatch(failure(error));
          props.history.push('/signin');
        } else {
          dispatch(failure(error));
          dispatch(alertActions.error(props.i18n.t('genericError')));
        }
      }
    );
  };

  function request(status) {
    return { type: licenseConstants.LICENSE_UPDATE_REQUEST, status };
  }
  function success(result) {
    return { type: licenseConstants.LICENSE_UPDATE_SUCCESS, result };
  }
  function failure(error) {
    return { type: licenseConstants.LICENSE_UPDATE_FAILURE, error };
  }
}

function getAll(pageNumber, status, props) {
  return dispatch => {
    dispatch(request());

    licenseService.getAll(pageNumber, status).then(
      response => {
        dispatch(success(response));
      },
      error => {
        if (error === 401) {
          console.log('unauthorized');
          dispatch(userActions.logout());
          dispatch(failure(error));
          props.history.push('/signin');
        } else {
          dispatch(failure(error));
          dispatch(alertActions.error(props.i18n.t('licensesGetError')));
        }
      }
    );
  };

  function request() {
    return { type: licenseConstants.LICENSE_GETALL_REQUEST };
  }
  function success(result) {
    return {
      type: licenseConstants.LICENSE_GETALL_SUCCESS,
      result,
    };
  }
  function failure(error) {
    return { type: licenseConstants.LICENSE_GETALL_FAILURE, error };
  }
}

function getAllForUser(userId, pageNumber, props) {
  return dispatch => {
    dispatch(request());

    licenseService.getAllForUser(userId, pageNumber).then(
      response => {
        dispatch(success(response));
      },
      error => {
        if (error === 401) {
          console.log('unauthorized');
          dispatch(userActions.logout());
          dispatch(failure(error));
          props.history.push('/signin');
        } else {
          dispatch(failure(error));
          dispatch(alertActions.error(props.i18n.t('licensesGetError')));
        }
      }
    );
  };

  function request() {
    return { type: licenseConstants.LICENSE_GETALL_USER_REQUEST };
  }
  function success(result) {
    return { type: licenseConstants.LICENSE_GETALL_USER_SUCCESS, result };
  }
  function failure(error) {
    return { type: licenseConstants.LICENSE_GETALL_USER_FAILURE, error };
  }
}

function getAllForAdmin(pageNumber, props) {
  return dispatch => {
    dispatch(request());

    licenseService.getAllForAdmin(pageNumber).then(
      response => {
        dispatch(success(response));
      },
      error => {
        if (error === 401) {
          console.log('unauthorized');
          dispatch(userActions.logout());
          dispatch(failure(error));
          props.history.push('/signin');
        } else {
          dispatch(failure(error));
          dispatch(alertActions.error(props.i18n.t('licensesGetError')));
        }
      }
    );
  };

  function request() {
    return { type: licenseConstants.LICENSE_GETALL_REQUEST };
  }
  function success(result) {
    return {
      type: licenseConstants.LICENSE_GETALL_SUCCESS,
      result,
    };
  }
  function failure(error) {
    return { type: licenseConstants.LICENSE_GETALL_FAILURE, error };
  }
}

function exportValidatedLicenses(props) {
  return dispatch => {
    dispatch(request());

    licenseService.exportValidatedLicense().then(
      response => {
        dispatch(success(response));
      },
      error => {
        if (error === 401) {
          console.log('unauthorized');
          dispatch(userActions.logout());
          dispatch(failure(error));
          props.history.push('/signin');
        } else {
          dispatch(failure(error));
          dispatch(alertActions.error(props.i18n.t('licensesExportError')));
        }
      }
    );
  };

  function request() {
    return { type: licenseConstants.LICENSE_EXPORT_REQUEST };
  }
  function success(result) {
    return {
      type: licenseConstants.LICENSE_EXPORT_SUCCESS,
      result,
    };
  }
  function failure(error) {
    return { type: licenseConstants.LICENSE_EXPORT_FAILURE, error };
  }
}



// WEBPACK FOOTER //
// ./src/actions/license.actions.js